<template>
    <div class="pdf-browser-wrapper">
        <div class="text-center pdf-files-label">
            <a href="#"
               class="mx-1"
               :class="{active: pdfFile.url === activeFileUrl}"
               v-for="(pdfFile, idx) in pdfFiles"
               :key="idx"
               @click.prevent="updateActiveFile(pdfFile)"
            >
                {{ pdfFile.label }}
            </a>
        </div>

        <div class="pdf-wrapper">
            <pdf-viewer v-if="activeFileUrl" :helpEmailAddress="helpEmailAddress" :pdfurl="activeFileUrl"></pdf-viewer>
        </div>
    </div>
</template>

<script>
import PdfViewer from "./PdfViewer.vue";

export default {
    name: "JudgingPdfMaterialBrowser",
    components: {PdfViewer},
    props: {
        /**
         * @type {Array<{url: string, label: string}>}
         */
        pdfFiles: {
            type: Array,
            required: true,
        },

        helpEmailAddress: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            activeFileUrl: null,
        }
    },

    watch: {
        pdfFiles: {
            handler() {
                if (this.pdfFiles.length === 0) {
                    this.activeFileUrl = null;
                } else if (!this.activeFileUrl || !this.pdfFiles.filter(pdfFile => pdfFile.url === this.activeFileUrl).length) {
                    this.activeFileUrl = this.pdfFiles[0].url;
                }
            },
            immediate: true,
        },
    },

    methods: {
        updateActiveFile(pdfFile) {
            this.activeFileUrl = pdfFile.url;
        }
    }
}
</script>

<style lang="scss" scoped>
.pdf-browser-wrapper {

}
.pdf-wrapper {
    max-height: 800px;
    overflow: auto;
    padding: 20px;
    //background-color: #f9f9f9;
  background: white;
  div {border: 1px solid #979797;}
}
.pdf-files-label {
  height: 31px;
  a {
    border-radius: 8px 8px 0px 0px;
    background-color: rgba(238, 238, 238, 1);
    color:#D07200;
    padding: 10px 20px;
    text-transform:uppercase;
    &.active {
      color: #0F0F0F;
      background-color: white;
    }
  }
}
</style>